import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {GlobalProvider, useGlobalContext} from "./context/GlobalState";
import {BrowserRouter} from "react-router-dom";
import {LicenseInfo} from "@mui/x-license";
import CustomSnackbarProvider from "./components/CustomSnackbarProvider";
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from '@mui/material/CssBaseline';
import {getTheme} from "./theme";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE_KEY);

const RootApplication = () => {
    const {themeMode} = useGlobalContext();
    const theme = getTheme(themeMode);

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline enableColorScheme/>
            <CustomSnackbarProvider>
                <App/>
            </CustomSnackbarProvider>
        </ThemeProvider>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <GlobalProvider>
        <BrowserRouter>
            <RootApplication/>
        </BrowserRouter>
    </GlobalProvider>
);